<template>
    <div>
        <v-cookie></v-cookie>
        <div class="place">
            <span>位置：</span>
            <ul class="placeul">
                <li>首页</li>
                <li>短信</li>
                <li>绑定手机号码</li>
            </ul>
        </div>
        <div id="register_a">
            <div class="w750">
                <h1 class="mt20 f20 cff2104 tal">绑定手机号码</h1>
                <ul class="mt20 f14">
                <li  class="mb30 yz ">
                    <div class="l w100 h36 tar">选择验证方式：</div>
                    <div class="vocation">
                        <el-select v-model="type" placeholder="短信验证码" :disabled="selectShow">
                            <el-option
                                v-for="item in typeOptions"
                                :key="item.value"
                                :label="item.text"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </li>
                <li  class="mb30 yz">
                    <div class="l w100 h36 tar">验证手机号码：</div>
                    <div class="l h36">
                        <el-input placeholder="请输入手机号码" v-model="mobile" style="width:175px;" :disabled="inputDis" maxlength="11"></el-input>
                        <el-button type="primary" v-show="sendcodeShow" class="top_button" @click="sendcode()" style="margin-left: 15px;letter-spacing: 2px;" :disabled="mobile.trim().length == 11 ? false : true">获取验证码</el-button>
                        <el-button type="primary" v-show="sendcodeagainShow" class="top_button" @click="sendcode()" style="margin-left: 15px;letter-spacing: 2px;" :disabled="mobile.trim().length == 11 ? false : true">重新获取验证码</el-button>                        
                        <el-button type="primary" v-show="countShow" class="top_button" style="margin-left: 15px;letter-spacing: 2px;"><label style="color: red;">{{count}} </label>秒后重新发送</el-button>
                        <el-tag type="warning" style="letter-spacing: 1px;margin-left:10px;" v-show="countShow">短信验证码已发送请,注意查收</el-tag>
                    </div>
                </li> 
                <!-- <li  class="mb30 yz" v-show="countShow">
                    <div class="l w100 h36 tar">验证手机号码：</div>
                    <div class="l h36"><span class="cf06000" style="font-size: 14px;">{{mobile}}</span></div>
                    {{mobile.slice(0,3)}}****{{mobile.slice(7,11)}}
                    <div class="l f14 ml10 h36"><el-tag type="warning" style="letter-spacing: 1px;">验证码已发送请注意查收</el-tag></div>
                </li> -->

                <li  class="mb30 yz">
                    <div class="l w100 h36 tar">短信验证码：</div>
                    <div class="l h36">
                            <el-input placeholder="请输入下发的验证码" v-model="code" style="width:175px;"></el-input>
                    </div>
                </li>
                <li  class="mb30 yz">
                <div class="l w100 h36 tar"> &nbsp; </div>
                <div class="l ">
                    <el-button type="primary" class="top_button" @click="checkcode()" style="letter-spacing: 2px;" :disabled="code.trim().length != 0 ? false : true">提交</el-button>
                    <!-- <el-button type="primary" class="top_button" @click="goindex()" style="margin-left:15px;letter-spacing: 2px;">返回首页</el-button> -->
                </div>
                </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
import cookie from '@/components/cookie.vue'
import {isMobil, is_number} from '@/assets/js/checkFunction.js'
export default {
    components : {
        'v-cookie' : cookie,
    },
    data() {
        return {
            mobile: '',
            code: '',
            type: 'sms',
            typeOptions: [
                { text: '短信获取密码', value: 'sms'},
                { text: '语音获取密码', value: 'mobile'},
            ],
            count: 60,
            isShow: true,
            timer: false,
            sendcodeShow: true,
            countShow: false,
            inputDis: false,
            sendcodeagainShow: false,
            selectShow: false,
        }
    },
    methods:{
        sendcode(){
            if(!isMobil(this.mobile))
            {
                this.$message.error("请输入正确的手机号");
                return false;
            }
            var that = this
            let param = {'mobile': this.mobile, 'checkModel': this.type}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + "/user/sendmobilecode.json",
                data: param,
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'token': this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.timeSetInterval();
                    that.inputDis = true;
                    that.sendcodeShow = false;
                    that.sendcodeagainShow = false;
                    that.countShow = true;
                    that.selectShow = true;
                }
                else
                {
                    that.$alert(res.data.msg)
                    return false;
                }
            })
        },
        checkcode(){
            var that = this
            let param = {"loginSign":"", "verifyCode":this.code,"verifyType":"mobilecheck"}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + "/user/checkmobilecode.json",
                data: param,
                headers: {
                    'Content-type': 'application/json;charset=UTF-8',
                    'token': this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    alert("手机号码绑定成功!");
                    location.href = "/smssend?mobile="
                }
                else
                {
                    alert(res.data.msg)
                    return false;
                }
            })
        },
        timeSetInterval() {
            //60秒倒计时
            let that = this;
            if(!this.timer)
            {
                //这里用 ()=>箭头函数可以不用that  因为箭头函数的对象为全局对象 function() 的对象为局部对象
                this.timer = setInterval(function() {
                    if(that.count > 0 && that.count <= 60)
                    {
                        that.count--;
                    }
                    else
                    {
                        that.timer = false;
                        that.count = 60;
                        that.sendcodeagainShow = true;
                        that.countShow = false;
                        clearInterval(that.timer);
                    }
                }, 1000);
            }
        },
    }
}
</script>




// WEBPACK FOOTER //
// src/components/sms/bindmobile.vue